import styles from "./PublicationItem.module.scss";

export interface IPublication {
  image: string;
  heading: string;
  authors: string[];
  source: string;
  url: string;
}

export const PublicationItem: React.FC<IPublication> = ({
  image,
  heading,
  authors,
  source,
  url,
}) => {
  // join array with commas and add "and" before last item
  const authorsString = authors.join(", ").replace(/,([^,]*)$/, " and$1");
  return (
    <div className={styles.root}>
      <div className={styles.image}>
        <img src={image} alt={heading} title={source} />
      </div>
      <div className={styles.details}>
        <div className={styles.heading}>{heading}</div>
        <div className={styles.authors}>{authorsString}</div>
        <div className={styles.source}>{source}</div>
        <a href={url} target="_blank" rel="noopener noreferrer">
          Access article
        </a>
      </div>
    </div>
  );
};

export default PublicationItem;
